/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="82.74" height="71.56" viewBox="0 0 82.74 71.56" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M42.92,60a1.5,1.5,0,1,1,2.17,2.07,21.88,21.88,0,0,0,15.45,37H93.83a1.5,1.5,0,0,1,.15,3H60.9A24.87,24.87,0,0,1,42.92,60Z" transform="translate(-36 -41.5)" fill="#ffb81c"/><path d="M93.83,52.27a24.87,24.87,0,0,1,16.51,43.51,1.5,1.5,0,0,1-2-2.24A21.88,21.88,0,0,0,94.19,55.27H60.9a1.5,1.5,0,0,1-.14-3H93.83Z" transform="translate(-36 -41.5)" fill="#0e497b"/><path d="M68.12,41.94a1.5,1.5,0,0,1,2.22,2l-.1.11-9.72,9.71,9.92,9.92a1.48,1.48,0,0,1,.1,2l-.1.12a1.5,1.5,0,0,1-2,.1l-.11-.1-11-11a1.5,1.5,0,0,1-.1-2l.1-.11Z" transform="translate(-36 -41.5)" fill="#0e497b"/><path d="M84.5,88.75a1.5,1.5,0,0,1,2-.1l.11.1L97.39,99.52a1.5,1.5,0,0,1,.11,2l-.11.11-11,11a1.5,1.5,0,0,1-2.23-2l.11-.11,9.91-9.92L84.5,90.87a1.5,1.5,0,0,1-.1-2Z" transform="translate(-36 -41.5)" fill="#ffb81c"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoRevolvingArrowsOvalIcon';

export default Icon;
